import { render, staticRenderFns } from "./InfoPopup.vue?vue&type=template&id=73ba6dd2&scoped=true&"
import script from "./InfoPopup.vue?vue&type=script&lang=js&"
export * from "./InfoPopup.vue?vue&type=script&lang=js&"
import style0 from "./InfoPopup.vue?vue&type=style&index=0&id=73ba6dd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ba6dd2",
  null
  
)

export default component.exports